import { Button, Tabs } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { StickyContainer, Sticky } from 'react-sticky';
import useQuery from '../../../../util/useQuery';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import Tab6 from './Tab6';
import Tab7 from './Tab7';
import Tab7Edit from '../DataflowDetail/Tab7';
import ModalFail from '../../../../components/Shared/modal/fail';
import IconEnoughData from '../../../../assets/Images/icons/icon-enough-data';
import { useTranslation } from 'react-i18next';
import { ROUTER } from '../../../../constants/router';
import UserService from '../../../../services/UserService';
import Tab8 from './Tab8';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
    <DefaultTabBar
        {...props}
        className="bg-white z-50 w-full"
        style={{
            position: 'sticky',
            top: '0',
            zIndex: 10,
        }}
    />
);

export default function TabsDetail({
    loading,
    detail,
    editMode,
    metadataList,
    getDataFlowDetail,
    getMetadataList,
    databaseDetail,
    dataFlowInfo,
    currentUser
}) {
    const navigate = useNavigate();
    const { businessProcessId } = useParams();
    const params = useQuery();
    const { t } = useTranslation();
    const [personalData, setPersonalData] = useState();
    const [openTabDB, setOpenTabDB] = useState(false);
    const [isOpenFail, setIsOpenFail] = useState(false);
    const [isNoPermission, setIsNoPermission] = useState(false);

    const role = UserService.role().toLowerCase();
    const superAdmin = ['super admin'].includes(role);
    const [msgError, setMsgError] = useState({
        msg1: '',
        msg2: '',
    });
    
    useEffect(() => {
        if (detail?.collectDataDestruction?.storageLocation) {
            const storageLocation =
                detail?.collectDataDestruction?.storageLocation.find(
                    (m) => m === '42776e1af77c11ec8bf4fa163e89ed46'
                );
            if (storageLocation) {
                setOpenTabDB(true);
            }
        }
    }, [detail]);

    useEffect(() => {
        const newData = {
            categoryPersonalDataId: '',
            personalData: [],
            sensitiveData: [],
            personalDataTopic: [],
        };
        if (detail?.categoryPersonalData) {
            newData.categoryPersonalDataId =
                detail.categoryPersonalData.categoryPersonalDataId;
            if (detail.categoryPersonalData.personalDataAddOn) {
                newData.personalData = [
                    ...detail.categoryPersonalData.personalData,
                ];
                detail.categoryPersonalData.personalDataAddOn.forEach(
                    (element) => {
                        const newElement = {
                            personalDataOptionId:
                                element.personalDataOptionAddOnId,
                            name: element.personalDataOptionAddOnName,
                            metadata: element.metadata,
                        };
                        newData.personalData.push(newElement);
                    }
                );
            }

            if (detail.categoryPersonalData.sensitiveDataAddOn) {
                newData.sensitiveData = [
                    ...detail.categoryPersonalData.sensitiveData,
                ];
                detail.categoryPersonalData.sensitiveDataAddOn.forEach(
                    (element) => {
                        const newElement = {
                            sensitivePersonalDataOptionId:
                                element.sensitivePersonalDataOptionAddOnId,
                            name: element.sensitivePersonalDataOptionAddOnName,
                            metadata: element.metadata,
                        };
                        newData.sensitiveData.push(newElement);
                    }
                );
            }

            if (detail.categoryPersonalData.personalDataTopic) {
                newData.personalDataTopic = [
                    ...detail.categoryPersonalData.personalDataTopic,
                ];
            }
            setPersonalData({ ...newData });
        }

        const reviewById2 = dataFlowInfo?.reviewById2;
        const reviewDate1 = dataFlowInfo?.reviewDate;
        const reviewDate2 = dataFlowInfo?.reviewDate2;
        const reviewer = dataFlowInfo?.reviewer;
        const statusId = dataFlowInfo?.statusId;
        
        if (statusId === STATUS.WAITING_FOR_REVIEW) {
            if (superAdmin) {
                setIsNoPermission(false);
            } else {
                if (reviewDate1 && reviewDate2) {
                    console.log("currentUser", currentUser)
                    console.log("reviewer", reviewer)

                    if (currentUser === reviewer){
                        setIsNoPermission(false);
                    } else {
                        setIsNoPermission(true);
                    }
                }

                if (currentUser === reviewer && !reviewById2) {
                    setIsNoPermission(false);
                  } else if (currentUser === reviewById2 && reviewDate1 && !reviewDate2) {
                    setIsNoPermission(false);
                  } else if (currentUser === reviewer && reviewDate1  && !reviewById2) { 
                    setIsNoPermission(false); 
                  } else {
                    setIsNoPermission(true);
                  }
            }
        }

        // if (dataFlowInfo?.statusId === STATUS.WAITING_FOR_REVIEW) {
        //     if (superAdmin) {
        //         setIsNoPermission(false);
        //     } else {
        //         if (dataFlowInfo?.reviewer) {
        //             if (currentUser !== dataFlowInfo?.reviewer) {
        //                 setIsNoPermission(true);
        //             } else {
        //                 setIsNoPermission(false);
        //             }
        //         } else {
        //             setIsNoPermission(false);
        //         }
        //     }
        // } else {
        //     setIsNoPermission(false);
        // }
    }, [detail, dataFlowInfo]);


    const checkTab = async (key) => {
        if (detail?.collectData) {
            if (detail?.categoryPersonalData) {
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=${key}`
                );
            } else {
                setMsgError({
                    msg1: t('dataFlow.errMsgTab2'),
                    msg2: t('dataFlow.errMsg2Tab2'),
                });
                setIsOpenFail(true);
            }
        } else {
            setMsgError({
                msg1: t('dataFlow.errMsgTab1'),
                msg2: t('dataFlow.errMsg2Tab1'),
            });
            setIsOpenFail(true);
        }
    };

    const currentPackage = UserService.currentPackage();
    const checkPackage4 = useMemo(() => {
        return openTabDB && currentPackage === 4;
    }, [currentPackage, openTabDB]);

    const changePage = useCallback(
        (key) => {
            const tabNumber = Number(params.get('tab'));
            if (key === 'right' && tabNumber < 8) {
                if (tabNumber === 4) {
                    if (!checkPackage4) {
                        navigate(
                            `${
                                ROUTER.DS_INVENTORY.DATAFLOW
                            }/${businessProcessId}/view?tab=${tabNumber + 2}`
                        );
                        return;
                    } else {
                        checkTab(5);
                        return;
                    }
                }
                navigate(
                    `${
                        ROUTER.DS_INVENTORY.DATAFLOW
                    }/${businessProcessId}/view?tab=${tabNumber + 1}`
                );
            }
            if (key === 'left' && tabNumber > 1) {
                if (tabNumber === 6) {
                    if (!checkPackage4) {
                        navigate(
                            `${
                                ROUTER.DS_INVENTORY.DATAFLOW
                            }/${businessProcessId}/view?tab=${tabNumber - 2}`
                        );
                        return;
                    } else {
                        checkTab(5);
                        return;
                    }
                }
                navigate(
                    `${
                        ROUTER.DS_INVENTORY.DATAFLOW
                    }/${businessProcessId}/view?tab=${tabNumber - 1}`
                );
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [businessProcessId, params.get('tab')]
    );

    const operationsSlot = {
        left: (
            <Button
                disabled={params.get('tab') === '1'}
                onClick={() => changePage('left')}
                className="mr-4"
            >
                <LeftOutlined />
            </Button>
        ),
        right: (
            <Button
                disabled={params.get('tab') === '8'}
                onClick={() => changePage('right')}
            >
                <RightOutlined />
            </Button>
        ),
    };

    const bubble = detail && (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="text-error"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z"
                strokeWidth={0}
                fill="currentColor"
            />
        </svg>
    );

    return (
        <div className="bg-white rounded-xl p-4 py-6 my-4 col-span-2">
            <StickyContainer>
                <Tabs
                    tabBarExtraContent={operationsSlot}
                    onChange={(key) => {
                        if (key === '5') {
                            checkTab(key);
                        } else {
                            navigate(
                                `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=${key}`
                            );
                        }
                    }}
                    activeKey={params.get('tab') || '1'}
                    renderTabBar={renderTabBar}
                >
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('RoPA.DataCollection')}{' '}
                                {!detail?.collectData && bubble}
                            </span>
                        }
                        key={1}
                    >
                        <Tab1
                            collectData={detail?.collectData}
                            editMode={editMode}
                            isNoPermission={isNoPermission}
                            dataFlowInfo={dataFlowInfo}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('RoPA.TypeOfPersonalData')}{' '}
                                {!detail?.categoryPersonalData && bubble}
                            </span>
                        }
                        key={2}
                    >
                        <Tab2
                            categoryPersonalData={personalData}
                            editMode={editMode}
                            metadataList={metadataList}
                            getDataFlowDetail={getDataFlowDetail}
                            getMetadataList={getMetadataList}
                            isNoPermission={isNoPermission}
                            dataFlowInfo={dataFlowInfo}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('dataFlow.Reference')}{' '}
                                {detail?.referenceDocuments?.length === 0 &&
                                    bubble}
                            </span>
                        }
                        key={3}
                    >
                        <Tab3
                            referenceDocuments={detail?.referenceDocuments}
                            editMode={editMode}
                            metadataList={metadataList}
                            getDataFlowDetail={getDataFlowDetail}
                            getMetadataList={getMetadataList}
                            isNoPermission={isNoPermission}
                            dataFlowInfo={dataFlowInfo}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="flex items-center gap-1">
                                {t('RoPA.StorageAndDestruction')}{' '}
                                {!detail?.collectDataDestruction && bubble}
                            </span>
                        }
                        key={4}
                    >
                        <Tab4
                            collectDataDestruction={
                                detail?.collectDataDestruction
                            }
                            editMode={editMode}
                            isNoPermission={isNoPermission}
                            dataFlowInfo={dataFlowInfo}
                        />
                    </TabPane>
                    {openTabDB && currentPackage === 4 && (
                        <TabPane
                            tab={<span>{t('RoPA.Database')}</span>}
                            key={5}
                        >
                            {databaseDetail?.departmentId ? (
                                <Tab7
                                    loading={loading}
                                    databaseInfo={databaseDetail}
                                    editMode={editMode}
                                    getDataFlowDetail={getDataFlowDetail}
                                    isNoPermission={isNoPermission}
                                    dataFlowInfo={dataFlowInfo}
                                />
                            ) : (
                                <Tab7Edit
                                    loading={loading}
                                    databaseInfo={databaseDetail}
                                    getDataFlowDetail={getDataFlowDetail}
                                    editMode={editMode}
                                    isNoPermission={isNoPermission}
                                    dataFlowInfo={dataFlowInfo}
                                />
                            )}
                        </TabPane>
                    )}
                    <TabPane tab={<span>{t('dataFlow.Remarks')}</span>} key={6}>
                        <Tab5 remarks={detail?.remarks} editMode={editMode} isNoPermission={isNoPermission} dataFlowInfo={dataFlowInfo}/>
                    </TabPane>
                    <TabPane tab={t('dcdpo.DataControllerTab')} key={7}>
                        <Tab8 dcDpo={detail?.dcDpo} editMode={editMode} isNoPermission={isNoPermission} dataFlowInfo={dataFlowInfo}/>
                    </TabPane>
                    <TabPane
                        tab={<span>{t('dataFlow.DataDiagram')}</span>}
                        key={8}
                    >
                        <Tab6
                            isView
                            editMode={editMode}
                            getDataFlowDetail={getDataFlowDetail}
                            detail={detail}
                            dataFlowInfo={dataFlowInfo}
                            isNoPermission={isNoPermission}
                        />
                    </TabPane>
                </Tabs>
            </StickyContainer>
            <ModalFail
                icon={<IconEnoughData />}
                open={isOpenFail}
                title={t('dataFlow.notEnoughInformation')}
                text={
                    <>
                        {msgError?.msg1} <br />
                        {msgError?.msg2}
                    </>
                }
                handelClose={() => {
                    setIsOpenFail(false);
                    navigate(
                        `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=1`
                    );
                }}
            />
        </div>
    );
}
